import {
  Avatar,
  Chip,
  PaletteColor,
  Paper,
  styled,
  ThemeOptions,
  Typography,
} from '@mui/material'

export const AvatarContainer = styled(Paper)({
  position: 'relative',
  backgroundColor: 'transparent',
  width: 280,
  height: 520,
  cursor: 'pointer',
})

export const AvatarBody = styled('div')({
  textAlign: 'center',
  padding: '2rem 1rem 0',
})

export const BackgroundDecorator = styled('div')(({ theme }) => ({
  zIndex: -1,
  position: 'absolute',
  backgroundColor: theme.palette.primary.main,
  width: '100%',
  height: 90,
}))

export const AvatarImage = styled(Avatar)(({ theme }) => ({
  margin: 'auto',
  borderRadius: '50%',
  minWidth: 200,
  maxWidth: 200,
  minHeight: 200,
  border: `3px solid ${theme.palette.primary.light}`,
  fontSize: '5rem',
}))

export const Name = styled(Typography)({
  fontSize: '1.5rem',
})

export const SpecialtyArea = styled(Typography)({
  fontSize: '0.875rem',
})
export const AgeRange = styled(Typography)({
  fontSize: '0.875rem',
})

export const TitleContainer = styled('div')({
  height: 86,
  margin: '1rem 0',
})

export const LanguageContainer = styled('div')({
  height: 70,
})

export const Language = styled(Chip)({
  cursor: 'pointer',
  margin: '0 0.5rem 0.3rem 0',
  '& span': {
    fontSize: '0.875rem',
    fontFamily: '"brandon-grotesque", Sans-serif',
    color: '#6D6E70',
    textTransform: 'capitalize',
  },
})

export const Slots = styled('div')(({ theme }) => ({
  marginTop: '0.5rem',
  width: 'fit-content',
  margin: 'auto',
  '& >p:first-of-type': {
    fontSize: '1rem',
    display: 'flex',
    marginBottom: '0.3rem',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme?.palette?.grey?.[400],
  },
}))

export const SlotOption = styled('div')(
  ({ theme, available }: { theme?: ThemeOptions; available: number }) => ({
    fontSize: '1rem',
    display: 'flex',

    margin: '0 auto 0.3rem',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: available
      ? (theme?.palette?.primary as PaletteColor).main
      : theme?.palette?.grey?.[400],
    '& >div': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '26px',
      height: '26px',
      marginRight: '0.6rem',
      borderRadius: '50%',
      backgroundColor: available
        ? (theme?.palette?.primary as PaletteColor).main
        : theme?.palette?.grey?.[400],
      '& >svg': {
        fill: theme?.palette?.common?.white,
      },
    },
  })
)
